import { QuoteItem } from '@/features/quote/quoteApi';
import { AssetBalance, AssetBalances } from '@/types/balances';
import { normalizedBig } from '@cex/shared-modules';
import Big from 'big.js';
import { getEuroFormat } from './formatters';

export const calculatePortfolioValue = (
  assetsPortfolioBalances: AssetBalance[],
  quoteData: (QuoteItem | null)[]
): string => {
  const getLastPrice = (quoteData: (QuoteItem | null)[], assetId: string): string => {
    const assetQuote = quoteData?.find((quote) => quote?.market.includes(assetId)) || null;
    return assetQuote?.sellPrice || '0';
  };

  const assetTotalPrices: Big[] =
    assetsPortfolioBalances?.map((assetPortfolioData: AssetBalance) => {
      const { available, locked, assetId } = assetPortfolioData;
      const totalAsset = normalizedBig(available).plus(normalizedBig(locked));
      const lastPrice = assetId === 'eur' ? 1 : getLastPrice(quoteData, assetId);
      const totalPrice = totalAsset.times(lastPrice);
      return totalPrice;
    }) || [];

  const totalEuro = assetTotalPrices.reduce((total, value) => total.plus(value), normalizedBig(0)).toFixed();
  return getEuroFormat(totalEuro);
};

export const calculateEuroValue = (assetsPortfolioBalances, allMarketsInfo) => {
  if (!assetsPortfolioBalances) {
    return [];
  }

  const assetsValueEuro: AssetBalances = assetsPortfolioBalances?.map((data: AssetBalance) => {
    const total = Number(data.available) + Number(data.locked);
    const assetsLastPrice = (allMarketsInfo?.find((obj) => obj.basicCode === data.assetId) || {}).lastPrice || 0;
    const totalPrice = data.assetId === 'eur' ? total : (total * assetsLastPrice).toFixed(2);
    return { ...data, euroValue: totalPrice };
  });

  return assetsValueEuro;
};
